import Box from '@mui/material/Box'
import Text from '@mui/material/Typography'
import AgxChipLogo from '@public/images/customers/parallax/agx-chip-logo.png'
import BeaconChipLogo from '@public/images/customers/parallax/beacon-chip-logo.png'
import ChainioChipLogo from '@public/images/customers/parallax/chainio-chip-logo.png'
import GocometChipLogo from '@public/images/customers/parallax/gocomet-chip-logo.png'
import Logixboard from '@public/images/customers/parallax/logixboard-chip-logo.png'
import PaackChipLogo from '@public/images/customers/parallax/paack-chip-logo.png'
import ShiptheoryChipLogo from '@public/images/customers/parallax/shiptheory-chip-logo.png'
import ChipBarge from '@public/images/moving-chip-animation/chip-barge.png'
import ChipBottle from '@public/images/moving-chip-animation/chip-bottle.png'
import ChipContainer from '@public/images/moving-chip-animation/chip-container.png'
import ChipOil from '@public/images/moving-chip-animation/chip-oil.png'
import ChipRice from '@public/images/moving-chip-animation/chip-rice.png'
import ChipTruck from '@public/images/moving-chip-animation/chip-truck.png'
import ChipWheat from '@public/images/moving-chip-animation/chip-wheat.png'
import Image, { StaticImageData } from 'next/image'

import { spaceGrotesk } from '@/app/fonts'

export enum ChipType {
    ContainerShip = 'containerShip',
    Truck = 'truck',
    Barge = 'barge',
    Wheat = 'wheat',
    Rice = 'rice',
    Oil = 'oil',
    Bottle = 'bottle',
    CustomerAgx = 'customerAgx',
    CustomerBeacon = 'customerBeacon',
    CustomerLogixboard = 'customerLogixboard',
    CustomerPaack = 'customerPaack',
    CustomerShiptheory = 'customerShiptheory',
    CustomerGoComet = 'customerGoComet',
    CustomerChainio = 'customerChainio',
}

export const chipDetails: Record<
    string,
    { image: StaticImageData; text?: string; width?: number; height?: number }
> = {
    containerShip: {
        image: ChipContainer,
        text: '61 gCO₂e / tkm',
    },
    truck: {
        image: ChipTruck,
        text: '1.33 kgCO₂e / tkm',
    },
    barge: {
        image: ChipBarge,
        text: '0.03 kgCO₂e / tkm',
    },
    wheat: {
        image: ChipWheat,
        text: '6.065 kgCO₂e / kg',
    },
    rice: {
        image: ChipRice,
        text: '0.4867 kgCO₂e / EUR',
    },
    oil: {
        image: ChipOil,
        text: '0.062 kgCO₂e / kWh',
    },
    bottle: {
        image: ChipBottle,
        text: '0.362 kgCO₂e / USD',
    },
    customerAgx: {
        image: AgxChipLogo,
        width: 81.6,
        height: 48,
    },
    customerBeacon: {
        image: BeaconChipLogo,
        width: 105.75,
        height: 40,
    },
    customerLogixboard: {
        image: Logixboard,
        width: 159.88,
        height: 40,
    },
    customerPaack: {
        image: PaackChipLogo,
        width: 102.5,
        height: 44,
    },
    customerShiptheory: {
        image: ShiptheoryChipLogo,
        width: 115.28,
        height: 40,
    },
    customerGoComet: {
        image: GocometChipLogo,
        width: 136.54,
        height: 40,
    },
    customerChainio: {
        image: ChainioChipLogo,
        width: 89,
        height: 40,
    },
}

export const EmissionFactorChip = ({ type }: { type: ChipType }) => {
    const details = chipDetails[type]

    return `text` in details ? (
        <Box
            sx={{
                backgroundImage: `url(${details.image.src})`,
                backgroundSize: 'cover',
                width: 'max-content',
                height: '46px',
                padding: '12px 16px 12px 46px',
                borderRadius: '46px',
                display: 'flex',
                alignItems: 'center',
            }}
        >
            <Text
                sx={{
                    fontFamily: `${spaceGrotesk.style.fontFamily}`,
                    fontSize: '14px',
                    fontWeight: 500,
                    lineHeight: '17px',
                    whiteSpace: 'nowrap',
                }}
            >
                {details.text}
            </Text>
        </Box>
    ) : (
        <Image
            alt={`floating logo`}
            src={details.image}
            width={details.width}
            height={details.height}
        />
    )
}
